import _get from 'lodash/get'
import { baseRequest } from '.'

export const getBuyersLocations = async eventId => {
  const res = await baseRequest.get(`events/${eventId}/relationships/order_locations/`)
  return _get(res, 'data')
}

export default getBuyersLocations
